export default __webpack_public_path__ + "static/media/441.cfb50a3d.png";